export default __webpack_public_path__ + "static/media/clear-icon-white.5c256d40.svg";